import { ModalService } from './../shared/modal/modal.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {
  changePasswordRoute,
  clientAdministrationRoute,
  companyAdministrationRoute,
  deviceInteractionRoute,
  editProfileRoute,
  homeRoute,
  loginRoute,
  parkerAdministrationRoute,
  parkerRegistrationRoute,
  parkingRangerSessionsRoute,
  parkingRoute,
  reportsRoute,
  tagsAdministrationRoute,
  userManagementRoute,
  zoneDamageRoute,
  configurationAdministrationRoute,
  adminRoute,
  parkRoute,
  tagsPerParkerRoute,
  parkerRegistrationsRoute,
  falseRecordingsRoute,
  parkerTurnoverRoute,
  parkerExtractRoute,
  deviceStatusRoute,
  automaticParkingReportRoute,
  paymentReportRoute,
  userExtractRoute,
  tagMasterRoute,
  onBoardingWizardRoute,
  savedReportsRoute,
  parkingCardRoute,
  automaticParkingRoute,
  thirdPartyUserZoneAssignmentAdministrationRoute,
  parkingRangerZoneAssignmentAdministrationRoute,
  twoFactorAuthenticationRegistrationRoute,
  exportJobsRoute,
  fleetListAdministrationRoute,
  parkingCardAdminRoute,
  problemReportAdministrationRoute,
} from './../../core/routing/route-names';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ReportType, UserInfoDTO } from '../models/models.swagger.generated';
import { UserManagementComponent } from '../user-management/user-management.component';
import { Observable, filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ItemModel, DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { AccordionComponent, AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { ReportVisibilityService } from '../services/report-visibility.service';
import { ParkingIndicatorComponent } from '../shared/parking-indicator/parking-indicator.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { NgClass } from '@angular/common';

interface RouteIdentifier {
  route: string,
  id: string
}

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [NgClass, LanguageSelectorComponent, DropDownButtonModule, AccordionModule, RouterLinkActive, RouterLink, ParkingIndicatorComponent, TranslateModule]
})
export class NavigationComponent implements OnInit {

  public loading = false;
  public userInfoModels: UserInfoDTO[] = [];
  public userInfoModels$: Observable<UserInfoDTO[]>;
  public userManagementComponent: UserManagementComponent;

  public homeRoute = homeRoute;
  public loginRoute = loginRoute;
  public configurationAdministrationRoute = configurationAdministrationRoute;
  public userManagementRoute = userManagementRoute;
  public clientAdministrationRoute = clientAdministrationRoute;
  public companyAdministrationRoute = companyAdministrationRoute;
  public parkerAdministrationRoute = parkerAdministrationRoute;
  public fleetListAdministrationRoute = fleetListAdministrationRoute;
  public tagsAdministrationRoute = tagsAdministrationRoute;
  public parkerRegistrationRoute = parkerRegistrationRoute;
  public parkingRangerSessionsRoute = parkingRangerSessionsRoute;
  public zoneDamageRoute = zoneDamageRoute;
  public savedReportsRoute = savedReportsRoute;
  public tagsPerParkerReportRoute = tagsPerParkerRoute;
  public parkerRegistrationsReportRoute = parkerRegistrationsRoute;
  public falseRecordingsReportRoute = falseRecordingsRoute;
  public parkerTurnoverReportRoute = parkerTurnoverRoute;
  public parkerExtractReportRoute = parkerExtractRoute;
  public deviceStatusReportRoute = deviceStatusRoute;
  public automaticParkingReportRoute = automaticParkingReportRoute;
  public paymentReportRoute = paymentReportRoute;
  public userExtractReportRoute = userExtractRoute;
  public exportJobsRoute = exportJobsRoute;

  public onBoardingWizardRoute = onBoardingWizardRoute;
  public tagMasterRoute = tagMasterRoute;
  public deviceInteraction = deviceInteractionRoute;
  public parkingRoute = parkingRoute;
  public automaticParkingRoute = automaticParkingRoute;
  public parkingCardRoute = parkingCardRoute;
  public parkingCardAdminRoute = parkingCardAdminRoute;
  public thirdPartyUserZoneAssignmentAdministrationRoute = thirdPartyUserZoneAssignmentAdministrationRoute;
  public parkingRangerZoneAssignmentAdministrationRoute = parkingRangerZoneAssignmentAdministrationRoute;
  public problemReportAdministrationRoute = problemReportAdministrationRoute;
  public adminSectionId = 'admin-section';
  public parkingSectionId = 'parking-section';
  public reportsSectionId = 'reports-section';

  public ReportType = ReportType;

  private subrouteMatch: RouteIdentifier = null;

  @ViewChild(AccordionComponent) public accordion: AccordionComponent;

  public userIcon = 'icon-user';
  public userNavigation: ItemModel[];

  private isAccordionInitialized = false;

  public envInfo = null;

  public get hasLinkedParker(): boolean {
    const user = this.authService.getUserInfo();
    return user.linkedParkers?.length > 0;
  }

  public get hasActiveClient(): boolean {
    const user = this.authService.getUserInfo();
    return user.linkedParkers.some(lp => lp.client.isActive);
  }

  public get hasAutomaticParking(): boolean {
    const user = this.authService.getUserInfo();
    return user.linkedParkers.some(lp => lp.client.automaticParkingSchedulesEnabled);
  }

  constructor(
    private router: Router,
    private modalService: ModalService,
    private translate: TranslateService,
    public authService: AuthService,
    private reportVisibilityService: ReportVisibilityService) {
  }

  public ngOnInit(): void {
    this.setUserNavigationPoints();
    this.translate.onLangChange.subscribe(_ => {
      this.setUserNavigationPoints();
    });
    this.envInfo = environment.envInfoClass?.length > 0 ? environment.envInfoClass : null;

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
      const subroutes: RouteIdentifier[] = [{ route: adminRoute + '/', id: this.adminSectionId }, { route: parkRoute + '/', id: this.parkingSectionId }, { route: reportsRoute + '/', id: this.reportsSectionId }];
      const url = this.router.url + '/';
      this.subrouteMatch = subroutes.find(s => url?.toLocaleLowerCase().indexOf(s.route) > -1);

      if (this.isAccordionInitialized) {
        this.expandAccordionSection(this.subrouteMatch?.id);
      }
    });
  }

  public onSelection(event: any): void {
    switch (event.item.id) {
      case 'editProfile':
        this.editUser();
        break;
      case 'changePassword':
        this.changePassword();
        break;
      case 'logout':
        this.logout();
        break;
      case 'register2FA':
        this.register2FA();
        break;
    }
  }

  public editUser() {
    this.router.navigate([editProfileRoute]);
  }

  public logout() {
    const dialog = this.modalService.showOkCancelDialog('i18n.core.modal.logout.title', 'i18n.core.modal.logout.question');
    dialog.onOkSubject.subscribe(() => {
      this.router.navigate([loginRoute], { queryParams: { init: 'true' } })
        .then(() => { this.authService.logout(); });
    });
  }

  public changePassword() {
    this.router.navigate([changePasswordRoute]);
  }

  public register2FA() {
    const dialog = this.modalService.showOkCancelDialog('i18n.base.two-factor-authentication.registration.messages.logout-to-register.title', 'i18n.base.two-factor-authentication.registration.messages.logout-to-register.message');
    dialog.onOkSubject.subscribe(() => {
      this.router.navigate([twoFactorAuthenticationRegistrationRoute], { queryParams: { init: 'true' } })
        .then(() => { this.authService.logout(); });
    });
  }

  public onAccordionCreated() {
    this.isAccordionInitialized = true;
    if (this.subrouteMatch) {
      this.expandAccordionSection(this.subrouteMatch.id);
    }
  }

  public canUserSeeReport(reportType: any): boolean {
    return this.reportVisibilityService.canUserSeeReport(reportType);
  }

  // expand or collapse
  private expandAccordionSection(htmlElementId: string) {
    for (let i = 0; i < this.accordion.element.children.length; i++) {
      const item = this.accordion.element.children.item(i);
      if (item.id == htmlElementId) {
        this.accordion.expandItem(true, i);
      } else {
        this.accordion.expandItem(false, i);
      }
    }
  }

  private setUserNavigationPoints() {
    this.userNavigation = [
      { text: this.translate.instant('i18n.core.navigation.editProfile'), id: 'editProfile', iconCss: 'icon-user--profile' },
      { text: this.translate.instant('i18n.core.navigation.changePassword'), id: 'changePassword', iconCss: 'icon-password' },
    ];

    if (this.authService?.getUserInfo()?.shouldUseTwoFactorAuth) {
      this.userNavigation.push({ text: this.translate.instant('i18n.base.two-factor-authentication.registration.header'), id: 'register2FA', iconCss: 'icon-two-factor-authentication' });
    }

    this.userNavigation.push({ text: this.translate.instant('i18n.core.navigation.logout'), id: 'logout', iconCss: 'icon-logout' });
  }
}
